export const VIEWPORT_ONCE = { once: true, margin: "-80px" };
export const VIEWPORT_ONCE_TIGHT = { once: true };

export const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: VIEWPORT_ONCE,
  transition: { duration: 0.7 },
};

export const fadeUpSmall = {
  initial: { opacity: 0, y: 16 },
  whileInView: { opacity: 1, y: 0 },
  viewport: VIEWPORT_ONCE_TIGHT,
  transition: { duration: 0.5 },
};

export const fadeIn = {
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: VIEWPORT_ONCE_TIGHT,
};

export const enterUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] },
});

export const staggered = (base, i, step = 0.08) => ({ ...base, transition: { ...base.transition, delay: i * step } });
